 import { Helmet } from "react-helmet-async";
import { useLocales } from "src/locales";
import NonBrandedOverviewSection from "src/sections/overview/dashboards/views/non-branded/views/search-terms";

export default function NonBrandedOverview() {
    const { t } = useLocales();
    return (
        <>
            <Helmet>
                <title>Non Branded Overview</title>
            </Helmet>

            <NonBrandedOverviewSection />
        </>
    );
}